import Box from '@mui/material/Box'
import { alpha, Button, Typography, useMediaQuery } from '@mui/material'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import FormModalContainer from './FormModalContainer'
import modalGreenBG from '../../images/modalGreenBG.svg'
import greenCheck from '../../images/greenCheck.svg'
import UseTranslation from '../../hooks/UseTranslation'
import closeIcon from '../../images/close.svg'
import circlePaperIconPopUp from '../../images/circlePaperIconPopUp.svg'

const FinishModalContainerV2 = ({
  modalState, modalIcon, modalData, actionAfterSuccess,
  customStyle, children, customModalStyle,
  cancelText, mediumSize, largeSize,
  customMessageStyle, disappearCancelButton, showCirclePaperIcon,
}) => {
  const { t } = UseTranslation()
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))
  return (

    <FormModalContainer
      modalState={modalState}
      handleClose={actionAfterSuccess}
      modalTitle={t?.[modalData?.header] || modalData?.header}
      customStyle={customStyle}
      customModalStyle={customModalStyle}
      mediumSize={mediumSize}
      largeSize={largeSize}
      cancelText={cancelText || <img src={closeIcon} alt="Close Icon" />}
       disappearCancelButton={disappearCancelButton}
    >
      <Box sx={styles.modalTxt}>
        <Box sx={styles.iconBox}>
         {showCirclePaperIcon && isXsScreen ? (
            <LazyLoadImage className="circlePaperIconPopUp" effect="blur" src={circlePaperIconPopUp} alt="Finish" />
         ) : (
            <>
              <LazyLoadImage effect="blur" src={modalGreenBG} alt="Finish-bg" />
              <LazyLoadImage className="greenCheck" effect="blur" src={modalIcon || greenCheck} alt="Finish" />
            </>
         )}
        </Box>

        <Typography variant="heading3" className="message" sx={[(showCirclePaperIcon && isXsScreen) ? styles.requestBody : styles.message, customMessageStyle]}>
          {t?.[modalData?.body] || modalData?.body}
        </Typography>

        <Typography variant="h6" className="subMessage" sx={styles.subMessage}>
          {t?.[modalData?.subBody] || modalData?.subBody}
        </Typography>
      </Box>

      {children}
      <Box sx={styles.formModalBtnsContainer}>
        <Button sx={styles.confirmButton} type="button" onClick={actionAfterSuccess}>
          {t?.[modalData?.confirmText] || modalData?.confirmText || t?.Finish}
        </Button>
      </Box>
    </FormModalContainer>
  )
}

const styles = {
  formModalBtnsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: { xs: '5px -15px 0 -15px', sm: '20px -15px 0 -15px' },
    padding: { xs: '10px 15px 0', sm: '20px 15px 0' },
    borderTop: '1px solid #cbcbcb',
  },
  confirmButton: {
    width: { xs: '100%', sm: 'fit-content' },
    color: 'white',
    borderRadius: '10px',
    backgroundColor: 'primary.main',
    border: 0,
    padding: '10px 20px',
    fontSize: 'typography.fontSize',
    fontWeight: 'typography.fontWeightBold',
    lineHeight: 1.43,
    textTransform: 'capitalize',
    minWidth: '110px',
    '&:hover, &:focus': {
      backgroundColor: alpha('#29cc8b', 0.75),
    },
    '&.disabled': {
      backgroundColor: alpha('#29cc8b', 0.5),
      pointerEvents: 'none',
    },
  },
  modalTxt: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '20px 10px',
    margin: 'auto',
    maxWidth: '380px',
  },
  message: {
    textTransform: 'inherit',
    fontSize: { xs: '14px', sm: '16px' },
    '& span': {
      color: 'primary.main',
    },
  },
  subMessage: {
    color: '#000000c7',
    fontSize: { xs: '14px', sm: '16px' },
    fontFamily: 'Avenir-light',
  },
  iconBox: {
    position: 'relative',
    minHeight: { xs: '170px', sm: '270px' },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& span:nth-child(1)': {
      position: 'absolute',
      top: '-40px',
      bottom: '0',
      right: '0',
      left: '0',
      transform: 'translateX(-100%)',
      zIndex: -1,
    },
  },

}

export default FinishModalContainerV2
